var React = require('react');

function Comment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.813-1.332H2.84A2.842,2.842,0,0,0,0,1.507V10.67A2.842,2.842,0,0,0,2.83,13.51v4.158L8.805,13.51h9.008a2.843,2.843,0,0,0,2.839-2.84V1.507a2.842,2.842,0,0,0-2.839-2.839ZM15.125,9.317h-9.6V8.107h9.6Zm0-2.581h-9.6V5.525h9.6Zm0-2.581h-9.6V2.944h9.6Zm0,0","transform":"translate(-0.001 1.332)","fill":"#fff"}));
}

Comment.defaultProps = {"viewBox":"0 0 20.651 19"};

module.exports = Comment;

Comment.default = Comment;
